import { IUserAuth } from "../../../model/respone/auth/IUserAuth";
import { eReducerStatusBase } from "../eReducerStatusBase";
export enum eAccountReducerStatus {
    is_getting_profile,
    is_get_profile_done,
    is_logging_in,
    is_log_in_success,
    is_log_in_error,
}
export interface IAuthReducer {
    status?: eAccountReducerStatus,
    user?: IUserAuth,
    ticket?: string,
    is_creating_ticket?: boolean
    isSignOuted?: boolean
}